module.exports = __webpack_public_path__ + "img/sort_icon.864022d5.svg";